import { createStyles } from '@material-ui/core';

export default () =>
  createStyles({
    loader: {
      left: 0,
      top: 0,
      background: 'rgba(255, 255, 255, .6)',
      zIndex: 2000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100vw',
      height: '100vh',
    },
  });



// WEBPACK FOOTER //
// ./src/components/loader/_styles.js